<!--
Emitted events:
- input(value)
-->
<template>
  <div :class="{ error }" class="form-auth-code">
    <label v-for="(_, index) in size" class="digit">
      <input
        ref="inputs"
        :value="code.charAt(index)"
        class="digit-input"
        type="tel"
        @focus="handleFocus($event, index)"
        @paste.prevent="handlePaste"
        @input="handleInput(index, $event.data)"
        @keydown.left="focusIndex(index - 1)"
        @keydown.right="focusIndex(index + 1)"
        @keydown.home="focusIndex(0)"
        @keydown.up="focusIndex(0)"
        @keydown.down="focusIndex(size - 1)"
        @keydown.end="focusIndex(size - 1)"
        @keydown.delete.prevent="handleDelete(index)"
      />
    </label>
  </div>
</template>

<script>
  export default {
    name: 'FormAuthCode',
    props: {
      value: {
        type: String,
        required: false,
        default: '',
      },
      size: {
        type: Number,
        required: false,
        default: 6,
      },
      error: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    computed: {
      stringValue() {
        if (['string', 'number'].includes(typeof this.value)) {
          return this.value.toString().substring(0, this.size).trim();
        }

        return '';
      },
      code() {
        return this.stringValue.padEnd(this.size, ' ');
      },
      lastAccessibleIndex() {
        return Math.min(this.stringValue.length, this.size - 1);
      },
    },
    methods: {
      replaceCharAt(index, newChar) {
        this.$emit('input', `${this.code.substring(0, index)}${newChar}${this.code.substring(index + 1)}`.trim());
      },
      focusIndex(index) {
        index = Math.min(Math.max(index, 0), this.lastAccessibleIndex);

        this.$refs.inputs[index].focus();
      },
      handleFocus($event, index) {
        if (index <= this.lastAccessibleIndex) {
          return;
        }

        $event.preventDefault();
        this.focusIndex(this.lastAccessibleIndex);
      },
      handleInput(currentIndex, value) {
        if (!value.match(/\d/)) {
          return;
        }

        this.replaceCharAt(currentIndex, value);
        this.$forceUpdate();
        this.$nextTick(() => this.focusIndex(currentIndex + 1));
      },
      handlePaste($event) {
        const code = $event.clipboardData?.getData('text').match(new RegExp(`\\d{${this.size}}`))?.[0];

        this.$emit('input', code);
      },
      handleDelete(currentIndex) {
        if (currentIndex !== this.lastAccessibleIndex) {
          return;
        }

        if (this.code.charAt(currentIndex) !== ' ') {
          this.replaceCharAt(currentIndex, ' ');
        } else if (currentIndex > 0) {
          this.replaceCharAt(currentIndex - 1, ' ');
          this.$nextTick(() => this.focusIndex(currentIndex - 1));
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .form-auth-code {
    display: inline-flex;
  }

  .digit {
    padding: 0 0.5rem;

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }

    input {
      width: 3.5rem;
      height: 5rem;
      font-size: 3rem;
      text-align: center;
      border: none;
      border-bottom: 1px solid $inputAuthCodeBorderColor;
      padding: 0;
      caret-color: transparent;
      color: $textColor;

      .error & {
        border-color: $inputErrorColor;
        color: $inputErrorColor;
      }

      &:focus {
        outline: none;
        background-color: $inputAuthCodeBackgroundColor;
      }
    }
  }
</style>
